import React, { forwardRef, Ref, useState } from 'react';

import { StyledFiledInput } from './FileInput.styles';

import { FileInputProps } from './FileInput.types';

const FileInput = forwardRef(
  (
    {
      label,
      showFileName = false,
      truncateFileName = (name: string) => name,
      handleChangeFiles = () => {},
      componentClassname = 'file-input',
      customClassnames = '',
      customStyle = '',
      ...props
    }: FileInputProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    const [fileName, setFileName] = useState<string | undefined>();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setFileName(e.target.files?.[0].name);
      handleChangeFiles(e.target.files);
    };

    return (
      <StyledFiledInput
        className={`${componentClassname} ${customClassnames}`}
        customStyle={customStyle}
      >
        <label htmlFor="file" className={`${componentClassname}__label`}>
          {label}
          <input
            ref={ref}
            type="file"
            id="file"
            {...props}
            className={`${componentClassname}__input`}
            onChange={handleChange}
          />
        </label>
        {fileName && showFileName && (
          <div className={`${componentClassname}__file-name`}>
            {truncateFileName(fileName)}
          </div>
        )}
      </StyledFiledInput>
    );
  },
);
FileInput.displayName = 'FileInput';

export default FileInput;
